import Vue from 'vue';
import { gsap } from 'gsap/all';
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

Vue.component('slider-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiperSlider: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.init();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        init() {
            this.initSwiper();
        },

        initSwiper() {
            this.swiperSlider = new Swiper('.swiper-container', {
                modules: [Navigation, Pagination],
                direction: 'horizontal',
                loop: true,
                slidesPerView: 1.5,
                centeredSlides: true,
                spaceBetween: 20,

                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: '.module__slider-next',
                    prevEl: '.module__slider-prev',
                },
                breakpoints: {
                    768: {
                        spaceBetween: 40,
                    },
                    1280: {
                        spaceBetween: 50,
                    },
                    1920: {
                        spaceBetween: 60,
                    },
                },
            });

            this.swiperSlider.on('touchStart', () => {
                console.log('touch start');
                const slides = this.$el.querySelectorAll('.swiper-slide');
                const images = this.$el.querySelectorAll('.swiper-slide img');

                gsap.to(slides, {
                    duration: 0.5,
                    scale: 0.97,
                });

                gsap.to(images, {
                    duration: 0.5,
                    scale: 1.03,
                });
            });

            this.swiperSlider.on('touchEnd', () => {
                const slides = this.$el.querySelectorAll('.swiper-slide');
                const images = this.$el.querySelectorAll('.swiper-slide img');

                gsap.to(slides, {
                    duration: 0.4,
                    scale: 1,
                });

                gsap.to(images, {
                    duration: 0.5,
                    scale: 1,
                });
            });
        },

        destroySwiper() {
            if (!this.swiperSlider) {
                return;
            }

            this.swiperSlider.destroy();
            this.swiperSlider = null;
        },
    },
});
